import Config from '@/models/config.model';
import Dealer from '@/models/dealer.model';
import FilterGroup from '@/models/filter-group.model';
import Translations from '@/models/translations.model';
import FilterGroupFilterCombi from './filter-group-filter-combi';
import { Map } from 'leaflet';
import MarkerIcon, { MarkerIconType } from '@/models/marker-icon.model';
import Place from '@/models/place.model';
import { DealerDetails } from '@/models/dealer-details.model';

export default class State {
    config: Config;
    translations: Translations;
    filters: Array<FilterGroup>;
    markerIcons: Record<MarkerIconType, MarkerIcon>;
    searchTerm: string;
    selectedFilters: Array<FilterGroupFilterCombi>;
    dealers: Array<Dealer>;
    mapZoom: number;
    mapCenter: [number, number];
    map: Map | null;
    stateUrl: string | null;
    hasValidParams: boolean;
    showMap: boolean;
    mapInitialized: boolean;
    myPlace: Place | null;
    activeMarkerId: string | null;
    activeDealerDetails: DealerDetails | null;
    submit: boolean;
    dealerListOpen: boolean;

    constructor(state: State | Record<string, any> = {}) {
        this.config = state.config;
        this.translations = state.translations;
        this.filters = state.filters;
        this.markerIcons = state.markerIcons;
        this.searchTerm = '';
        this.selectedFilters = [];
        this.dealers = [];
        this.mapZoom = this.config.map.zoom;
        this.mapCenter = this.config.map.center;
        this.map = null;
        this.stateUrl = null;
        this.hasValidParams = false;
        this.showMap = false;
        this.mapInitialized = false;
        this.myPlace = null;
        this.activeMarkerId = null;
        this.activeDealerDetails = null;
        this.submit = false;
        this.dealerListOpen = true;

        this.init();
    }

    private init(): void {
        this.readUrlParams();
    }

    /**
     * Reads the URL params and
     * sets the state 
     */
    private readUrlParams(): void {
        const urlParams = new URLSearchParams(location.search);
        const place = urlParams.get('place');
        const term = urlParams.get('term');

        this.submit = !!urlParams.get('submit');

        let hasValidParams = {
            place: false,
            term: false,
        };

        if (place) {
            const splittedPlace = place.split(',');

            if (splittedPlace.length === 2) {
                const lat = +splittedPlace[0];
                const lng = +splittedPlace[1];

                if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
                    this.myPlace = { lat, lng };
                    hasValidParams.place = true;
                }
            }
        }

        if (term) {
            this.searchTerm = term;
            hasValidParams.term = true;
        }

        if (Object.keys(hasValidParams).every(key => hasValidParams[key])) {
            // if all map relevant URL params
            // are set the map should already
            // be shown initially
            this.hasValidParams = true;
            this.showMap = true;
        }

        this.selectFilters(urlParams);
    }

    /**
     * Selects filters based on the set
     * URL params
     * @param urlParams URLSearchParams object
     */
    private selectFilters(urlParams: URLSearchParams): void {
        this.filters.forEach(filterGroup => {
            const filterGroupName = filterGroup.name;

            if (!urlParams.has(filterGroupName)) {
                return;
            }

            const paramValue = urlParams.get(filterGroupName);

            if (!paramValue) {
                return;
            }

            const splittedParamValue = paramValue.split(',');

            filterGroup.filters.forEach(filter => {
                if (splittedParamValue.indexOf(filter.value) === -1) {
                    return;
                }

                // the value of the current filter
                // was found in the URL params
                // so we push it to the selected filters

                this.selectedFilters.push(
                    new FilterGroupFilterCombi(filterGroup, filter)
                );
            });
        });
    }
}
